import { UserTypes } from "../actions/user";
import { getStoredState } from "../utilities/LocalStorage";

const initialState = {
  payload: {
    selectedProgram: null,
    completedInARow: 0,
    totalCompleted: 0,
    programStarted: null,
    dayEntries: {},
    subscribedPrograms: [],
    user: {},
    token: "",
    ...getStoredState()
    // token:
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1ZDQwNTZiNjRmMjM5ZjUzNzRmYzllZTciLCJpYXQiOjE1NjQ0OTc2NzZ9.xR7A_OwOKEQ4bw2skUGPjjBGS16Sr0RrHxWa9TTfjLw"
  }
};

const normalize = programs =>
  programs.map(program => ({
    ...program.program,
    added: program.added
  }));

const user = (state = initialState, { type, payload }) => {
  switch (type) {
    case UserTypes.LIST_PROGRAMS_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
          subscribedPrograms: normalize(payload.subscribedPrograms)
        }
      };

    case UserTypes.SWITCH_PROGRAM_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          selectedProgram: payload.selectedProgram,
          subscribedPrograms: normalize(payload.subscribedPrograms)
        }
      };

    case UserTypes.GET_FEED_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload
        }
      };

    case UserTypes.LOGIN_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          token: payload.token,
          user: payload.user
        }
      };

    case UserTypes.LOGOUT:
      return {
        ...state,
        payload: {
          ...state.payload,
          token: "",
          user: {}
        }
      };

    default:
      return state;
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js